import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { useFetchGlobalServiceProfileQuery } from '@module/queries/global-service/globalServiceQueryHooks';
import { useGetSubtitleApplyCheckQuery } from '@module/queries/subtitle/subtitleQueryHooks';
function useGlobalServiceViewModel() {
  const $ = _c(12);
  const {
    userInfo
  } = useGetLoginInfoQuery();
  const t0 = userInfo?.isBJ === "Y";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      enabled: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: canAccessGlobalService
  } = useGetSubtitleApplyCheckQuery(t1);
  const nickJa = userInfo?.nickJa || "";
  const userIdx = userInfo?.idx || 0;
  let t2;
  if ($[2] !== userIdx) {
    t2 = {
      userIdx
    };
    $[2] = userIdx;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !!userIdx;
  let t4;
  if ($[4] !== t3) {
    t4 = {
      enabled: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data
  } = useFetchGlobalServiceProfileQuery(t2, t4);
  const jaProfileData = data?.ja;
  const koProfileData = data?.ko;
  const isAllEmptyGlobalProfileData = Object.values(koProfileData || {}).every(_temp);
  let t5;
  if ($[6] !== canAccessGlobalService || $[7] !== isAllEmptyGlobalProfileData || $[8] !== jaProfileData || $[9] !== koProfileData || $[10] !== nickJa) {
    t5 = {
      jaProfileData,
      koProfileData,
      isAllEmptyGlobalProfileData,
      canAccessGlobalService,
      nickJa
    };
    $[6] = canAccessGlobalService;
    $[7] = isAllEmptyGlobalProfileData;
    $[8] = jaProfileData;
    $[9] = koProfileData;
    $[10] = nickJa;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(value) {
  return !value;
}
export default useGlobalServiceViewModel;